let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("98bRK")).then(() => parcelRequire('27yeK'));